var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map-wrapper"},[_c('iframe',{ref:"map",staticClass:"w-full h-full",attrs:{"src":"/_embed/map"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }